import React from 'react';
import { FaCheckCircle, FaExclamationCircle, FaSpinner } from 'react-icons/fa';

const FormStatus = ({ status, message }) => {
  if (!status) return null;

  const statusConfig = {
    loading: {
      icon: <FaSpinner className="spinner" />,
      className: 'status-loading',
      message: 'Submitting...'
    },
    success: {
      icon: <FaCheckCircle />,
      className: 'status-success',
      message: message || 'Successfully submitted!'
    },
    error: {
      icon: <FaExclamationCircle />,
      className: 'status-error',
      message: message || 'Something went wrong. Please try again.'
    }
  };

  const config = statusConfig[status];

  return (
    <div className={`form-status ${config.className}`}>
      <div className="status-icon">{config.icon}</div>
      <p>{config.message}</p>
    </div>
  );
};

export default FormStatus; 